module.exports = function() {
    ICF.Utils.EqualHeights.RegisterSetEqualHeights(".featured-content-columns-column", 0);
};